document.addEventListener('DOMContentLoaded', function () {
  const currentCustomerTagsElement = document.getElementById("krf-customer-tags");

  if (!currentCustomerTagsElement) {
    window.location.href = "/pages/wine-profile-not-found";
    return;
  }

  const currentCustomerTags = currentCustomerTagsElement.value.trim();

  if (currentCustomerTags) { 
    const pageRouteCustomerTagMap = {
      'le pépin voyageur': 'le-pepin-voyageur',
      'le raisin vif': 'le-raisin-vif',
      'le cep tranquille': 'le-cep-tranquille',
      'la vrille curieuse': 'la-vrille-curieuse',
      'la grappe joyeuse': 'la-grappe-joyeuse',
    };

    const customerTagKeys = Object.keys(pageRouteCustomerTagMap).map(tag => tag.toLowerCase());
    const customerTagsArray = currentCustomerTags.split(',').map(tag => tag.trim().toLowerCase());
    const customerTag = customerTagsArray.find(tag => customerTagKeys.includes(tag));

    const hasLessThan40Tag = customerTagsArray.some(tag => !isNaN(tag) && Number(tag) < 35);

    console.log('Wine Profile:', customerTag ? pageRouteCustomerTagMap[customerTag] : 'No match');
    console.log('Has Less Than 40 Tag:', hasLessThan40Tag);

    if (customerTag) {
      const wineProfilePath = pageRouteCustomerTagMap[Object.keys(pageRouteCustomerTagMap).find(key => key.toLowerCase() === customerTag)];
      const finalPath = hasLessThan40Tag 
        ? `/pages/${wineProfilePath}-v1` 
        : `/pages/${wineProfilePath}-v2`;

      window.location.href = finalPath;
    } else {
      console.log('No matching path found for customer tags, redirecting...');
      window.location.href = "/pages/wine-profile-not-found";
    }
  } else {
    console.log('No customer tags found, redirecting...');
    window.location.href = "/pages/wine-profile-not-found";
  }
});
